module.exports = __webpack_public_path__ + "static/img/3.d01318b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin_activity/3.png
// module id = 0phf
// module chunks = 0